import type { KAPLAYCtx } from "kaplay";
import * as C from "./constants";
import { createJumpController } from "./jump-controller";

export function createPlayer(k: KAPLAYCtx) {
  k.setGravity(Math.abs(C.GRAVITY));

  const player = k.add([
    k.circle(C.PLAYER_SIZE / 2),
    k.pos(
      C.PLAYER_HORIZONTAL_POSITION * C.GRID_CELL_SIZE,
      (C.VISIBLE_GRID_HEIGHT - C.PLAYER_START_Y) * C.GRID_CELL_SIZE,
    ),
    k.anchor("center"),
    k.area(),
    k.body(),
    k.opacity(0),
    "player",
    { worldX: C.PLAYER_START_X, isAlive: true, currentRotation: 0 },
  ]);

  const playerVisual = k.make([k.rotate(0)]);

  playerVisual.add([
    k.rect(C.PLAYER_SIZE, C.PLAYER_SIZE),
    k.color(120, 80, 50),
    k.pos(0, 0),
    k.anchor("center"),
  ]);

  const tapeColor = [200, 170, 140] as const;

  // tape strip (horizontal)
  playerVisual.add([
    k.rect(C.PLAYER_SIZE, C.PLAYER_SIZE * 0.15),
    k.color(...tapeColor),
    k.pos(0, 0),
    k.anchor("center"),
  ]);

  // tape strip (vertical)
  playerVisual.add([
    k.rect(C.PLAYER_SIZE * 0.15, C.PLAYER_SIZE),
    k.color(...tapeColor),
    k.pos(0, 0),
    k.anchor("center"),
  ]);

  playerVisual.add([
    k.rect(C.PLAYER_SIZE * 0.3, C.PLAYER_SIZE * 0.2),
    k.color(200, 40, 80),
    k.pos(C.PLAYER_SIZE * 0.25, -C.PLAYER_SIZE * 0.25),
    k.anchor("center"),
  ]);

  player.add(playerVisual);

  const jumpController = createJumpController(k, player);

  player.onUpdate(() => {
    const dt = k.dt();
    jumpController.update(dt);
  });

  return {
    player,
    jump: () => jumpController.handleJumpInput(),
    jumpRelease: () => jumpController.handleJumpRelease(),
  };
}
